import { useQuery } from 'react-query';

import { Enterprise } from '@/domain/models/Enterprise';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { EnterpriseService } from '@/services/Enterprise';

interface UseEnterprise {
  enterprise?: Enterprise;
  isLoading: boolean;
  isError: Error | null;
}
export const useEnterprise = (): UseEnterprise => {
  const enterpriseService = new EnterpriseService(getClient());

  const {
    data: enterprise,
    error,
    isLoading,
  } = useQuery<Enterprise, Error>('enterprise', () =>
    enterpriseService.fetch().catch((error: Error) => errorHandler({ error }))
  );

  return {
    enterprise,
    isLoading,
    isError: error,
  };
};
